module.exports = __webpack_public_path__ + "media/images/icons/error-8f4f6cd0904ee69f1b7213e48f35012a.svg";